import React, {Component} from 'react';
import {
  Autocomplete, Box, Chip,
  Fade,
  IconButton,
  Modal,
  Paper,
  TextField,
  Typography,
  Unstable_Grid2 as Grid,
} from '@mui/material';
import {withTheme} from '@mui/styles';
import {Close} from '@mui/icons-material';
import './MaterialNameStandardsModal.scss';
import {createMaterialNameStandard, deleteMaterialNameStandard, getMaterialNameStandards} from '../../../services/knestKontrol';

class MaterialNameStandardsModal extends Component {
  constructor(props) {
    super(props);

    this.defaultSate = {
      materialNameStandards: [],
      loading: true,
    };

    this.state = {
      ...this.defaultSate,
    };
  }

  fetchAndRefreshData = async () => {
    await this.setState({loading: true});

    const materialNameStandards = (await getMaterialNameStandards())

    await this.setState({
      loading: false,
      materialNameStandards,
    });
  };

  async componentDidMount() {
    await this.fetchAndRefreshData();
  }

  closeModal = async () => {
    this.props.confirm();
    this.props.setOpen(false);
  };

  handleMaterialNameStandardChange = async (reason, option) => {
    if (reason === 'removeOption') {
      await deleteMaterialNameStandard(option.key);
    } else {
      await createMaterialNameStandard({key: option});
    }

    await this.fetchAndRefreshData();
  };

  render() {
    const {open} = this.props;

    return (
      <Modal open={open} closeAfterTransition={true}>
        <Fade in={open} timeout={250}>
          <Box className={'material-name-standards-modal'}>
            <Paper sx={{height: '100%'}}>
              <IconButton
                size={'small'}
                className={'close-material-name-standards-modal-button'}
                onClick={this.closeModal}
              >
                <Close />
              </IconButton>
              <Grid
                container
                spacing={2}
                className={'material-name-standards-modal-content'}
              >
                <Grid xs={12}>
                  <Typography>Editing Material Name Standards</Typography>
                </Grid>
                <Grid xs={12} alignItems={'flex-end'} sx={{width: '100%'}}>
                  <Autocomplete
                    fullWidth
                    multiple
                    freeSolo
                    disableClearable
                    options={this.state.materialNameStandards}
                    value={this.state.materialNameStandards}
                    getOptionLabel={option => option.key}
                    filterSelectedOptions
                    renderInput={params => <TextField {...params} label="Material Name Standards" />}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) =>
                        <Chip
                          variant={'filled'}
                          label={option.key}
                          {...getTagProps({index})}
                        />)
                    }
                    onChange={(event, newValue, reason, {option}) => this.handleMaterialNameStandardChange(reason, option)}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Box>
        </Fade>
      </Modal>
    );
  }
}

export default withTheme(MaterialNameStandardsModal);